import React, { useEffect } from 'react';
import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';
import { StatsigSessionReplayPlugin } from '@statsig/session-replay';
import Loader from 'components/Loader';
import { useAuth } from 'context/AuthContext';

const StatsigWrapper = ({ children }: { children: React.ReactNode }) => {
  const statsigClientKey = process.env.REACT_APP_STATSIG_CLIENT_KEY;

  const { user, isLoading, isInitialized } = useAuth();

  const uuid =
    sessionStorage.getItem('uuid') ||
    localStorage.getItem('uuid') ||
    crypto.randomUUID();

  const shouldInitializeStatsig = isInitialized && !isLoading;
  const userID = user?.localAccountId || uuid;

  const hasValidUser =
    shouldInitializeStatsig && (user?.localAccountId || uuid);

  const { client } = useClientAsyncInit(
    statsigClientKey ?? '',
    { userID, customIDs: { stableID: uuid } },
    {
      plugins: [
        new StatsigAutoCapturePlugin(),
        new StatsigSessionReplayPlugin()
      ]
    }
  );

  useEffect(() => {
    const updateUser = async () => {
      if (hasValidUser) {
        await client.updateUserAsync({
          userID,
          customIDs: { stableID: uuid }
        });
      }
    };

    updateUser();
  }, [client, hasValidUser, uuid, userID]);

  if (!statsigClientKey) {
    console.warn(
      'Statsig client key not found. Statsig features will be disabled.'
    );

    return <>{children}</>;
  }

  if (!client) {
    console.warn(
      'Statsig client failed to initialize. Statsig features will be disabled.'
    );

    return <>{children}</>;
  }

  return (
    <StatsigProvider
      client={client}
      loadingComponent={<Loader isVisible={true} />}
    >
      {children}
    </StatsigProvider>
  );
};

export default StatsigWrapper;
